var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenanceSp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 343 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M199.386 5.29082L8.03217 115.152C3.22047 117.923 0.494949 122.275 0.519698 127.099C0.543416 132.366 3.85365 137.296 9.64191 140.63L88.4491 186.013C88.5759 186.086 92.4492 188.294 92.5967 188.34C97.4548 190.99 103.495 192.327 109.38 192.09C114.138 192.09 119.512 190.445 122.923 188.481L313.22 79.2269C318.03 76.4559 320.758 72.1019 320.731 67.2809C320.708 62.0104 317.396 57.0814 311.611 53.7497L229.567 6.5025C227.848 5.513 225.455 4.43401 223.461 3.79731C220.192 2.75329 216.644 2.13922 213.051 2.10322C207.859 2.05282 203.103 3.15033 199.386 5.29082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M199.542 5.62105L8.18804 115.483C3.57228 118.141 0.994223 122.283 1.04166 126.854C1.09013 131.83 4.25289 136.509 9.79675 139.702L88.9772 185.3C89.2309 185.446 92.8711 187.499 93.1671 187.59C98.1489 190.162 104.305 191.336 110.055 190.862C114.337 190.862 120.337 188.714 123.407 186.946L312.646 78.2992C317.259 75.6413 319.84 71.4981 319.79 66.9281C319.741 61.9497 316.578 57.2707 311.037 54.08L229.489 7.11765C227.941 6.22689 225.238 4.95967 223.449 4.36926C220.22 3.30467 216.706 2.61963 213.136 2.54763C207.987 2.44682 203.221 3.5001 199.541 5.62002L199.542 5.62105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M199.693 5.94865L8.33938 115.81C3.92058 118.355 1.48896 122.286 1.56011 126.607C1.6323 131.293 4.64863 135.721 9.94809 138.773L89.5019 184.586C89.8834 184.805 93.2906 186.703 93.735 186.839C98.8406 189.333 105.114 190.344 110.729 189.632C114.535 189.632 121.159 186.982 123.889 185.41L312.071 77.3698C316.489 74.8251 318.922 70.8928 318.849 66.5727C318.777 61.8854 315.76 57.4573 310.462 54.4076L229.409 7.73017C228.033 6.93815 225.02 5.47858 223.435 4.93857C220.247 3.85238 216.766 3.09637 213.219 2.98939C208.112 2.83819 203.34 3.84827 199.693 5.94762V5.94865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M199.848 6.27748L8.49507 116.139C4.27221 118.571 1.98805 122.291 2.08292 126.361C2.17985 130.755 5.04872 134.932 10.1038 137.843L90.0309 183.872C90.5392 184.164 93.7144 185.906 94.3063 186.087C99.5356 188.504 105.925 189.352 111.405 188.403C114.736 188.403 121.985 185.249 124.374 183.874L311.499 76.4407C315.72 74.0091 318.007 70.2877 317.91 66.2186C317.813 61.8234 314.943 57.6453 309.89 54.7354L229.333 8.34391C228.129 7.65167 224.807 5.99461 223.424 5.50912C220.274 4.40133 216.83 3.57537 213.304 3.4324C208.241 3.23079 203.459 4.19664 199.849 6.27645L199.848 6.27748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M200.001 6.60538L8.64737 116.467C4.62147 118.785 2.48375 122.295 2.60234 126.114C2.72299 130.216 5.44542 134.143 10.2561 136.914L90.5565 183.158C91.1917 183.524 94.1348 185.11 94.8742 185.337C100.227 187.675 106.733 188.361 112.078 187.174C114.933 187.174 122.808 183.517 124.855 182.339L310.923 75.5127C314.948 73.1942 317.089 69.6837 316.968 65.8655C316.847 61.7615 314.124 57.8343 309.315 55.0653L229.253 8.9588C228.222 8.3653 224.591 6.50869 223.41 6.0808C220.299 4.95141 216.891 4.05448 213.389 3.87653C208.368 3.62453 203.579 4.54717 200.002 6.60641L200.001 6.60538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M200.154 6.93555L8.80038 116.797C4.97145 119.002 2.97912 122.302 3.12246 125.87C3.26786 129.681 5.84283 133.357 10.4091 135.988L91.0828 182.446C91.8448 182.885 94.5559 184.316 95.4438 184.588C100.921 186.848 107.542 187.372 112.752 185.947C115.131 185.947 123.632 181.787 125.337 180.804L310.347 74.5849C314.176 72.3796 316.169 69.0799 316.025 65.5117C315.879 61.6997 313.303 58.0225 308.739 55.3945L229.172 9.57285C228.312 9.0781 224.375 7.01783 223.395 6.65166C220.32 5.50066 216.95 4.53379 213.471 4.31984C208.493 4.01744 203.696 4.89585 200.154 6.93555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M200.308 7.26382L8.95404 117.124C5.32103 119.217 3.47617 122.305 3.64323 125.623C3.81235 129.142 6.24089 132.568 10.5627 135.057L91.6097 181.73C92.4986 182.242 94.9777 183.518 96.0131 183.836C101.614 186.018 108.352 186.377 113.426 184.717C115.33 184.717 124.456 180.054 125.821 179.268L309.773 73.6552C313.406 71.563 315.252 68.4742 315.085 65.157C314.916 61.6361 312.487 58.2099 308.167 55.7217L229.095 10.185C228.407 9.78901 224.164 7.522 223.383 7.21959C220.344 6.04597 217.012 5.00915 213.555 4.76023C208.62 4.40743 203.814 5.24264 200.308 7.26176V7.26382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M200.461 7.59383L9.10659 117.455C5.67056 119.434 3.97213 122.312 4.16291 125.38C4.35678 128.607 6.63784 131.784 10.7153 134.131L92.1346 181.019C93.1514 181.604 95.3963 182.725 96.5802 183.088C102.305 185.192 109.159 185.389 114.099 183.491C115.526 183.491 125.278 178.324 126.301 177.735L309.197 72.7293C312.633 70.7503 314.332 67.8713 314.142 64.8061C313.948 61.5773 311.667 58.401 307.59 56.0538L229.013 10.803C228.497 10.5058 223.951 8.02687 223.367 7.79441C220.363 6.59816 217.07 5.49242 213.636 5.2075C208.744 4.8043 203.931 5.59528 200.46 7.59486L200.461 7.59383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M200.615 7.92292L9.26104 117.785C6.02197 119.65 4.46997 122.319 4.68344 125.134C4.90103 128.07 7.03566 130.996 10.8687 133.202L92.6613 180.305C93.8049 180.964 95.8179 181.928 97.1492 182.337C102.997 184.363 109.968 184.397 114.773 182.262C115.725 182.262 126.102 176.592 126.783 176.199L308.622 71.8004C311.862 69.9345 313.415 67.2664 313.2 64.4511C312.982 61.5135 310.848 58.5882 307.015 56.3819L228.932 11.416C228.589 11.2185 223.739 8.52362 223.352 8.36418C220.382 7.14531 217.13 5.96963 213.72 5.64974C208.87 5.19613 204.048 5.94391 200.612 7.92292H200.615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M200.769 8.2518L9.41607 118.113C6.37293 119.866 4.96737 122.323 5.20558 124.888C5.44792 127.533 7.43509 130.208 11.0237 132.273L93.1896 179.591C94.4601 180.323 96.241 181.132 97.7208 181.586C103.693 183.534 110.78 183.405 115.45 181.032C115.925 181.032 126.928 174.86 127.269 174.663L308.051 70.8713C311.095 69.1186 312.501 66.6613 312.263 64.097C312.02 61.4515 310.033 58.7761 306.445 56.7107L228.857 12.0298C228.685 11.9311 223.535 9.01707 223.342 8.93478C220.406 7.69224 217.194 6.44868 213.807 6.09279C209 5.58878 204.17 6.29336 200.769 8.25077V8.2518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.122 179.804L307.475 69.9439C313.22 66.6359 312.499 60.8584 305.868 57.0402L223.327 9.50601C216.695 5.68789 206.665 5.27337 200.921 8.58028L9.56665 118.442C3.82479 121.75 4.54253 127.527 11.1743 131.345L93.7135 178.878C100.345 182.696 110.376 183.11 116.121 179.803L116.122 179.804Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0112 181.194L11.8447 136.755C3.14117 131.742 4.2322 122.987 14.2825 117.198L195.738 12.7036C205.786 6.91672 220.992 6.28722 229.697 11.2995L306.864 55.7387C315.569 60.7511 314.476 69.5074 304.426 75.2943L122.971 179.788C112.923 185.578 97.7168 186.206 89.0122 181.192L89.0112 181.194Z",
    fill: "url(#paint0_linear_17733_76256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0111 179.875L11.8446 135.435C7.95583 133.196 6.02228 130.209 5.96969 127.073C5.96557 126.797 5.97485 120.762 6.00063 120.484C6.32031 116.852 9.12008 118.852 14.2834 115.879L195.738 11.3838C205.786 5.59487 220.992 4.96743 229.697 9.98078L306.864 54.4179C310.75 56.6561 312.685 52.7177 312.741 55.8507C312.744 56.1233 312.735 63.3193 312.71 63.595C312.4 67.2311 309.6 70.9967 304.426 73.9745L122.971 178.469C112.923 184.257 97.7167 184.886 89.0121 179.873L89.0111 179.875Z",
    fill: "url(#paint1_linear_17733_76256)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0112 173.28L11.8447 128.841C3.14117 123.826 4.2322 115.072 14.2825 109.283L195.738 4.78866C205.786 -1.00025 220.992 -1.62871 229.697 3.38463L306.864 47.8238C315.569 52.8362 314.476 61.5925 304.426 67.3794L122.971 171.875C112.923 177.664 97.7168 178.29 89.0122 173.279L89.0112 173.28Z",
    fill: "url(#paint2_linear_17733_76256)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.74 65.9173C312.729 65.4709 312.681 65.1819 312.597 64.9844C313.374 69.2222 310.595 73.894 304.425 77.4478L122.97 181.942C112.922 187.731 97.7158 188.359 89.0112 183.345L11.8448 138.907C8.0911 136.745 6.16683 133.885 5.99256 130.869C5.97296 132.158 5.96574 136.896 5.96987 137.141C6.02246 140.277 7.95601 143.263 11.8448 145.502L89.0123 189.942C97.7179 194.954 112.923 194.325 122.972 188.537L304.426 84.0411C309.598 81.0633 312.4 77.2976 312.711 73.6626C312.735 73.3869 312.745 66.1899 312.741 65.9163L312.74 65.9173Z",
    fill: "url(#paint3_linear_17733_76256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M11.845 127.973L89.0125 172.413C97.7181 177.427 112.924 176.796 122.972 171.009L304.426 66.5141C309.715 63.4674 312.52 59.5979 312.726 55.8867C312.944 59.856 310.131 64.0949 304.426 67.3792L122.972 171.875C112.924 177.664 97.7171 178.29 89.0125 173.279L11.845 128.84C7.72214 126.466 5.802 123.251 5.98453 119.911C6.15056 122.937 8.07895 125.806 11.845 127.973Z",
    fill: "url(#paint4_radial_17733_76256)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.324 110.584L197.997 5.96322C206.809 0.889184 220.136 0.33786 227.767 4.732L304.525 48.9356C312.156 53.3298 311.197 61.0061 302.387 66.0791L120.717 170.699C111.903 175.774 98.5755 176.325 90.9424 171.93L14.1873 127.728C6.55628 123.334 7.51223 115.658 16.324 110.584Z",
    fill: "url(#paint5_linear_17733_76256)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8455 112.092L200.616 7.99172C207.991 3.74467 219.147 3.28386 225.534 6.96107L300.657 50.2215C307.041 53.9008 306.242 60.3233 298.866 64.5714L118.094 168.672C110.721 172.92 99.5622 173.381 93.1779 169.701L18.0553 126.442C11.6699 122.764 12.4691 116.338 19.8455 112.092Z",
    fill: "#1F0D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.338 45.4623C285.631 47.5977 279.603 47.5864 275.872 45.4387L233.837 21.2308C230.106 19.0831 230.089 15.6106 233.794 13.4753L224.876 8.34053C218.857 4.87316 209.127 4.85567 203.145 8.30145L20.3834 113.55C14.4002 116.995 14.4311 122.598 20.4514 126.065L93.8313 168.323C99.8515 171.791 109.581 171.807 115.562 168.362L298.327 63.114C304.309 59.6682 304.277 54.0655 298.26 50.6002L289.339 45.4634L289.338 45.4623Z",
    fill: "#3D065F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.76 169.452C108.591 169.452 112.163 168.61 114.821 167.078L297.584 61.8299C299.984 60.4485 301.306 58.6937 301.306 56.8937C301.306 55.0936 299.961 53.2926 297.517 51.8844L289.307 47.157C287.418 48.055 285.087 48.5426 282.648 48.5426C279.836 48.5426 277.165 47.8976 275.131 46.7261L233.095 22.5182C230.804 21.1996 229.541 19.3573 229.541 17.3331C229.541 15.9949 230.095 14.7349 231.136 13.659L224.135 9.62792C221.434 8.07269 217.816 7.21484 213.951 7.21484C210.086 7.21484 206.55 8.05829 203.892 9.5878L21.129 114.837C18.7283 116.22 17.4062 117.971 17.4062 119.771C17.4062 121.571 18.7541 123.371 21.195 124.78L94.5769 167.037C97.2756 168.595 100.895 169.451 104.759 169.451L104.76 169.452Z",
    fill: "url(#paint6_linear_17733_76256)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.157 92.8928L278.57 88.0502C279.619 87.4444 280.471 85.8233 280.471 84.4286C280.471 83.0307 279.619 82.3878 278.57 82.9937L270.157 87.8373C269.108 88.4411 268.256 90.0632 268.256 91.46C268.256 92.8558 269.108 93.4976 270.157 92.8928Z",
    fill: "url(#paint7_linear_17733_76256)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.157 92.8928L278.57 88.0502C279.619 87.4444 280.471 85.8233 280.471 84.4286C280.471 83.0307 279.619 82.3878 278.57 82.9937L270.157 87.8373C269.108 88.4411 268.256 90.0632 268.256 91.46C268.256 92.8558 269.108 93.4976 270.157 92.8928Z",
    fill: "url(#paint8_linear_17733_76256)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.402 92.626C269.548 92.626 269.724 92.5705 269.907 92.4645L278.319 87.6219C279.215 87.1076 279.973 85.6429 279.973 84.4292C279.973 83.8902 279.8 83.2617 279.322 83.2617C279.176 83.2617 278.999 83.3173 278.818 83.4232L270.405 88.2658C269.509 88.7822 268.752 90.2469 268.752 91.4616C268.752 91.9996 268.92 92.627 269.402 92.627V92.626Z",
    fill: "url(#paint9_linear_17733_76256)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.14 101.543L263.549 96.6998C264.602 96.095 265.452 94.4739 265.452 93.0771C265.452 91.6803 264.602 91.0394 263.549 91.6432L255.14 96.4879C254.089 97.0917 253.238 98.7148 253.238 100.111C253.238 101.506 254.088 102.148 255.14 101.544V101.543Z",
    fill: "url(#paint10_linear_17733_76256)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M255.14 101.543L263.549 96.6998C264.602 96.095 265.452 94.4739 265.452 93.0771C265.452 91.6803 264.602 91.0394 263.549 91.6432L255.14 96.4879C254.089 97.0917 253.238 98.7148 253.238 100.111C253.238 101.506 254.088 102.148 255.14 101.544V101.543Z",
    fill: "url(#paint11_linear_17733_76256)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M254.384 101.273C254.53 101.273 254.708 101.217 254.89 101.111L263.304 96.2685C264.199 95.7511 264.957 94.2874 264.957 93.0727C264.957 92.5347 264.786 91.9062 264.308 91.9062C264.156 91.9062 263.984 91.9618 263.8 92.0657L255.385 96.9114C254.49 97.4267 253.734 98.8904 253.734 100.105C253.734 100.644 253.905 101.272 254.384 101.272V101.273Z",
    fill: "url(#paint12_linear_17733_76256)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.836 138.125L304.426 67.2147C309.598 64.2359 312.4 60.4713 312.711 56.8352C312.722 56.7149 312.73 55.2481 312.735 53.625C312.735 53.6548 312.735 61.1779 312.711 61.4515C312.4 65.0886 309.598 68.8543 304.426 71.8331L181.836 138.127V138.125Z",
    fill: "#3D065F"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M238.834 96.774C246.646 115.44 275.832 121.054 304.023 109.316C332.211 97.5773 348.732 72.9303 340.919 54.2644C333.104 35.5997 303.921 29.9846 275.731 41.7229C247.543 53.4611 231.022 78.1092 238.833 96.774H238.834Z",
    fill: "url(#paint13_radial_17733_76256)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M81.7029 168.351C77.6904 178.088 86.3599 190.866 101.062 196.893C115.767 202.921 130.936 199.913 134.95 190.178C138.96 180.442 130.291 167.664 115.588 161.636C100.887 155.61 85.7133 158.616 81.7029 168.351Z",
    fill: "url(#paint14_radial_17733_76256)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3721 153.057L57.1843 161.01C57.1843 158.492 55.6488 155.57 53.7566 154.481L46.7979 150.472C44.9056 149.383 43.3711 150.54 43.3711 153.057H43.3721Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.645 15.8659C160.645 17.9163 157.387 19.5775 153.373 19.5775C149.358 19.5775 146.1 17.9163 146.1 15.8659C146.1 13.8155 149.355 12.1543 153.373 12.1543C157.39 12.1543 160.645 13.8155 160.645 15.8659Z",
    fill: "url(#paint15_linear_17733_76256)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M198.254 91.6609V90.4434H198.235C197.695 94.4548 194.537 98.5647 188.859 101.843L174.062 110.387C162.618 116.993 145.308 117.71 135.398 111.988L114.695 100.034C110.559 97.6455 108.393 94.5124 108.074 91.193V92.6725H108.091C107.544 96.7445 109.702 100.711 114.695 103.594L135.397 115.546C145.308 121.268 162.617 120.553 174.061 113.944L188.859 105.402C195.649 101.481 198.847 96.3659 198.255 91.6624L198.254 91.6609Z",
    fill: "url(#paint16_linear_17733_76256)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M162.224 16.1548C162.224 19.0032 158.261 21.3095 153.372 21.3095C148.484 21.3095 144.52 19.0032 144.52 16.1548C144.52 13.3063 148.483 11 153.372 11C158.262 11 162.224 13.3078 162.224 16.1548Z",
    fill: "url(#paint17_linear_17733_76256)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.249 86.4519V85.2344H108.068V87.4635H108.085C107.538 91.5355 109.696 95.5045 114.689 98.3863L135.391 110.337C145.302 116.058 162.611 115.342 174.055 108.737L188.853 100.191C195.643 96.2723 198.841 91.1584 198.249 86.4519Z",
    fill: "url(#paint18_linear_17733_76256)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.394 106.78L114.69 94.8259C104.78 89.1063 106.023 79.1133 117.467 72.5047L132.267 63.9624C143.709 57.3539 161.018 56.6376 170.929 62.3587L191.633 74.3113C201.543 80.0325 200.299 90.027 188.856 96.634L174.057 105.176C162.615 111.785 145.306 112.501 135.395 106.78H135.394Z",
    fill: "url(#paint19_linear_17733_76256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M188.856 95.7657L174.059 104.311C162.616 110.917 145.305 111.634 135.396 105.913L114.692 93.9606C110.499 91.5392 108.324 88.3485 108.053 84.9761C107.776 88.8452 109.935 92.5795 114.692 95.325L135.396 107.278C145.307 113 162.616 112.282 174.059 105.675L188.856 97.1331C195.455 93.3231 198.64 88.3879 198.272 83.7949C197.971 87.9836 194.806 92.3342 188.856 95.7687V95.7657Z",
    fill: "url(#paint20_radial_17733_76256)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M162.223 16.1211H144.519L125.268 81.2826H125.277C125.277 81.3568 125.268 81.4325 125.268 81.5082C125.268 90.5473 137.85 97.8766 153.372 97.8766C168.894 97.8766 181.476 90.5473 181.476 81.5082C181.476 81.4325 181.467 81.3568 181.466 81.2826H181.476L162.225 16.1211H162.223Z",
    fill: "url(#paint21_linear_17733_76256)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M181.474 81.2835L177.652 68.3496C177.663 68.5041 177.673 68.657 177.673 68.813C177.673 76.6269 166.793 82.9644 153.372 82.9644C139.95 82.9644 129.068 76.6254 129.068 68.813C129.068 68.657 129.079 68.5041 129.088 68.3496L125.266 81.2835H125.275C125.272 81.3577 125.266 81.4334 125.266 81.5091C125.266 90.5481 137.848 97.8775 153.37 97.8775C168.892 97.8775 181.474 90.5481 181.474 81.5091C181.474 81.4334 181.465 81.3577 181.464 81.2835H181.474Z",
    fill: "url(#paint22_linear_17733_76256)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M169.931 42.216C169.936 42.3054 169.946 42.3932 169.946 42.4856C169.946 47.816 162.525 52.1379 153.369 52.1379C144.213 52.1379 136.79 47.816 136.79 42.4856C136.79 42.3811 136.811 42.2827 136.816 42.1797L132.918 55.374C132.923 55.4967 132.927 55.5906 132.927 55.6481C132.927 62.2203 142.078 67.5507 153.369 67.5507C164.66 67.5507 173.809 62.2203 173.809 55.6481C173.809 55.5921 173.823 55.5027 173.832 55.424L169.93 42.216H169.931Z",
    fill: "url(#paint23_linear_17733_76256)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.225 16.1211H162.221C162.221 16.1332 162.225 16.1438 162.225 16.1559C162.225 19.0044 158.262 21.3107 153.374 21.3107C148.486 21.3107 144.521 19.0044 144.521 16.1559C144.521 16.1438 144.524 16.1332 144.524 16.1211H144.521L140.658 29.1943V29.3185C140.658 33.4087 146.351 36.725 153.374 36.725C160.397 36.725 166.088 33.4087 166.088 29.3185V29.1943L162.225 16.1211Z",
    fill: "url(#paint24_linear_17733_76256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M160.643 15.864C160.643 17.9144 157.385 19.5756 153.371 19.5756C149.356 19.5756 146.098 17.9144 146.098 15.864C146.098 13.8136 149.353 12.1523 153.371 12.1523C157.388 12.1523 160.643 13.8136 160.643 15.864Z",
    fill: "url(#paint25_linear_17733_76256)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M160.759 13.8058L155.035 14.9082L161.136 80.0939H161.139C161.153 80.1666 161.165 80.2408 161.18 80.315C162.89 89.192 168.345 95.6037 173.365 94.6345C178.382 93.6669 181.066 85.6879 179.355 76.8124C179.342 76.7382 179.325 76.6655 179.31 76.5913H179.313L160.759 13.8027V13.8058Z",
    fill: "url(#paint26_radial_17733_76256)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M147.21 13.8058L152.934 14.9082L146.833 80.0939H146.828C146.815 80.1666 146.804 80.2408 146.79 80.315C145.079 89.192 139.623 95.6037 134.606 94.6345C129.586 93.6669 126.904 85.6879 128.612 76.8124C128.629 76.7382 128.644 76.6655 128.658 76.5913H128.655L147.208 13.8027L147.21 13.8058Z",
    fill: "url(#paint27_radial_17733_76256)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17733_76256",
    x1: 312.739,
    y1: 96.2477,
    x2: 5.96774,
    y2: 96.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F054A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5824B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17733_76256",
    x1: 272.407,
    y1: 94.9269,
    x2: -34.3656,
    y2: 94.9269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2F0D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F105E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17733_76256",
    x1: 312.739,
    y1: 88.3318,
    x2: 5.96774,
    y2: 88.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58098A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E3BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17733_76256",
    x1: -55.323,
    y1: 129.154,
    x2: 251.451,
    y2: 129.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2F0D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F105E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_17733_76256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.822 122.176) scale(116.602 116.304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17733_76256",
    x1: 309.676,
    y1: 88.3317,
    x2: 9.03534,
    y2: 88.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F054A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E1D9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17733_76256",
    x1: 17.4063,
    y1: 93.7415,
    x2: 301.306,
    y2: 93.7415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17733_76256",
    x1: 313.378,
    y1: 65.462,
    x2: 300.589,
    y2: 72.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17733_76256",
    x1: 313.378,
    y1: 65.462,
    x2: 300.589,
    y2: 72.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F054A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5824B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17733_76256",
    x1: 349.219,
    y1: 95.2748,
    x2: 360.203,
    y2: 102.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17733_76256",
    x1: 298.357,
    y1: 74.1117,
    x2: 285.571,
    y2: 81.5129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17733_76256",
    x1: 298.357,
    y1: 74.1117,
    x2: 285.571,
    y2: 81.5129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F054A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5824B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17733_76256",
    x1: 341.182,
    y1: 108.236,
    x2: 352.168,
    y2: 115.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_17733_76256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.78 75.2654) rotate(157.392) scale(55.2908 36.4263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_17733_76256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.973 177.573) rotate(-157.711) scale(28.7739 18.9563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17733_76256",
    x1: 160.463,
    y1: 15.8659,
    x2: 144.357,
    y2: 15.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17733_76256",
    x1: -359.684,
    y1: 104.925,
    x2: -359.532,
    y2: 104.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A21BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C133B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_17733_76256",
    x1: 133.189,
    y1: 6.06329,
    x2: 159.71,
    y2: 19.3242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17733_76256",
    x1: 198.785,
    y1: 99.7174,
    x2: 106.843,
    y2: 99.7174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A21BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C133B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17733_76256",
    x1: 206.351,
    y1: -16.8012,
    x2: 145.623,
    y2: 98.9343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_17733_76256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.514 97.8388) scale(25.8587 25.8587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_17733_76256",
    x1: 132.126,
    y1: 52.1106,
    x2: 179.275,
    y2: 62.0461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E7DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D5BFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C7AEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B396DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A788DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A383DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AD8DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8A6DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_17733_76256",
    x1: 127.835,
    y1: 75.7108,
    x2: 174.25,
    y2: 85.4691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD2CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC17A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_17733_76256",
    x1: 133.381,
    y1: 49.3182,
    x2: 179.799,
    y2: 59.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD2CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC17A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_17733_76256",
    x1: 138.982,
    y1: 22.7024,
    x2: 185.396,
    y2: 32.4592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD2CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC17A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_17733_76256",
    x1: 153.371,
    y1: 12.9867,
    x2: 153.371,
    y2: 40.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_17733_76256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.835 54.4693) rotate(-10.9) scale(8.72425 26.4371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0C033D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#070222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#03000F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#000003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_17733_76256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.995 54.2942) rotate(-169.1) scale(8.72425 26.4371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceSp);
export default __webpack_public_path__ + "static/media/maintenance_sp.f4ef54c89ba980368bd13829e5c13fa8.svg";
export { ForwardRef as ReactComponent };